<template>
  <div style="padding-right: 2%">
    <loading :loading="sendingData" />
    <form v-if="!sendingData" @submit.prevent="submit">
      <md-field>
        <label for="tipo">Tipo</label>
        <md-select
          id="tipo"
          v-model="pontoSig.tipo"
          name="tipo"
          @md-selected="changeTipo"
        >
          <md-option :value="1"> Rede </md-option>
          <md-option :value="2"> Hidrômetro </md-option>
          <md-option :value="3"> Reservatório </md-option>
          <md-option :value="4"> Conjunto moto-bomba </md-option>
          <md-option :value="5"> Válvula </md-option>
          <md-option :value="6"> Vazamento </md-option>
        </md-select>
      </md-field>

      <formulario-rede-sig
        v-if="pontoSig.tipo === 1"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <formulario-hidrometro-sig
        v-if="pontoSig.tipo === 2"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <formulario-reservatorio-sig
        v-if="pontoSig.tipo === 3"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <formulario-moto-bomba-sig
        v-if="pontoSig.tipo === 4"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <formulario-valvula-sig
        v-if="pontoSig.tipo === 5"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <formulario-vazamento-sig
        v-if="pontoSig.tipo === 6"
        :data="dadosAssociados"
        @change="handleFormChange"
      />

      <div style="text-align: right" />
      <slider-right ref="slider" style="text-align: left">
        <p class="md-display-1">Fotos</p>
        <formulario-fotos @change="handleFotosChange" />
      </slider-right>
      <div style="text-align: left">
        <md-button class="md-raised md-accent" @click="cancelar">
          Cancelar
        </md-button>
        <md-button class="md-primary" @click.stop="createOpenFotosTab">
          Anexar Fotos
        </md-button>
        <md-button class="md-raised md-primary" type="submit">
          Salvar
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../utils/http'
import Loading from '../Loading'
import SliderRight from '../SliderLeft'
import FormularioFotos from './FormularioFotos'
import FormularioHidrometroSig from './FormularioHidrometroSig'
import FormularioMotoBombaSig from './FormularioMotoBombaSig'
import FormularioRedeSig from './FormularioRedeSig'
import FormularioReservatorioSig from './FormularioReservatorioSig'
import FormularioValvulaSig from './FormularioValvulaSig'
import FormularioVazamentoSig from './FormularioVazamentoSig'

export default {
  name: 'FormularioPontoSig',
  components: {
    Loading,
    FormularioFotos,
    SliderRight,
    FormularioVazamentoSig,
    FormularioValvulaSig,
    FormularioMotoBombaSig,
    FormularioReservatorioSig,
    FormularioHidrometroSig,
    FormularioRedeSig,
  },
  props: {
    localId: String,
    localizacao: Object,
    pontoSigId: String,
    dadosAssociados: Object,
  },
  data() {
    return {
      sendingData: false,
      pontoSig: {
        id: null,
        tipo: 1,
        formularioInternos: {
          isValid: false,
          data: null,
        },
        fotos: [],
      },
    }
  },
  beforeMount() {
    if (this.pontoSigId) {
      this.pontoSig.id = this.pontoSigId
    }

    this.pontoSig.formularioInternos.data = this.dadosAssociados
  },
  methods: {
    async submit() {
      const isValid = this.pontoSig.formularioInternos.isValid

      if (!isValid) {
        this.$notify({
          group: 'main',
          title: 'Mensagem',
          text: 'Formulário preenchido de forma incorreta',
          type: 'warn',
          duration: 7000,
          speed: 600,
          position: 'bottom right',
        })

        return
      }

      this.sendingData = true

      const result = await http.post('ponto-sig', {
        id: this.pontoSig.id,
        localId: this.localId,
        tipo: this.pontoSig.tipo,
        localizacao: this.localizacao,
        dadosAssociados: this.pontoSig.formularioInternos.data,
        imagens: this.pontoSig.fotos,
      })

      this.sendingData = false

      if (result) {
        this.$emit('submit')
      }
    },
    changeTipo(data) {
      this.$emit('changeTipo', data)
    },
    handleFotosChange(fotos) {
      this.pontoSig.fotos = fotos
    },
    handleFormChange(data) {
      this.pontoSig.formularioInternos = { ...data }
    },
    createOpenFotosTab() {
      this.$refs.slider.toogleTab()
    },
    cancelar() {
      this.$emit('clickCancelar')
    },
  },
}
</script>

<style lang="scss" scoped></style>
